module.exports = __webpack_public_path__ + "img/icon_wangfei@2x.7d57cd00.png";